// extracted by mini-css-extract-plugin
module.exports = {"cancelRoundCard":"CancelRoundWidget_cancelRoundCard__2NN1K","cancelRoundText":"CancelRoundWidget_cancelRoundText__22VR5"};